<template>
  <div>
    <navBar />
    <div class="main main-container">
      <div class="banner">
        <img src="@/assets//images/caseCar/banner.png" />
        <div class="banner-title">合作案例</div>
      </div>
      <div class="title">合作案例</div>
      <div class="wrap-nav">
        <el-tabs v-model="titleStyle" @tab-click="clickTitle">
          <el-tab-pane label="服装" name="0">
            <div class="content-box">
              <div class="content-box-describe">
                <img src="@/assets//images/caseCar/clothing.png" />
                <div class="content-box-title">
                  <span>Calvin Klein</span>
                  <div>
                    以数据驱动CRM策略与运营流程优化，提高会员招募、转化、复购、客单价等主要KPI。利用营销自动化工具指定多场景业务推送，
                    利用企业微信搭建智能导购场景，通过任务机制来让导购参与到会员运营，提高销售转化。
                    基于小程序搭建会员社区，通过UGC内容与任务机制提高会员交易外的活跃度与社交场景转化。
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="化妆品" name="1">
            <div class="content-box">
              <div class="content-box-describe">
                <img src="@/assets/images/caseCar/winona.png" />
                <div class="content-box-title">
                  <span>薇诺娜</span>
                  <div>
                    隶属于上市公司贝泰妮集团，作为国内知名敏感肌药妆品牌，拥有大量会员与线下零售网点。英檬科技提供基于企业微信的智能导购解决方案。
                    通过对会员数据的整理与分配，将BA作为会员运营的一个重要环境，
                    建立B2B2C运营模式，导购可以接受到精准的会员运营与营销任务，来提高1对1的客户服务能力，提高业务转化。
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="消费品" name="2">
            <div class="content-box">
              <div class="content-box-describe">
              <img src="@/assets/images/caseCar/Octomore.png" />
              <div class="content-box-title">
                <span>Octomore</span>
                <div>
                  人头马集团旗下极具特色的威士忌品牌。英檬科技为其设计和搭建完整CRM规则与系统，以小程序建立会员触点，建立更有效的沟通机制。通过任务机制，徽章体系刺激会员与品牌的互动，提高会员对品牌的认知，增加整体销量增长。
                </div>
              </div>
            </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="汽车" name="3">
            <div class="content-box">
              <div class="content-box-describe">
                <img src="@/assets/images/caseCar/EVCARD.png" />
                <div class="content-box-title">
                  <span>EVCARD</span>
                  <div>
                    上汽集团旗下知名电动车分时租赁平台。通过线索系统进行有效的新客管理，并通过优化线索管理流程，提高首单转化率。
                    利用企业微信搭建客户社群，解决客户使用中的问题及服务。根据用户的使用习惯与场景打通APP，进行自动化内容推送，
                    提高会员使用频次。
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  data() {
    return {
      titleStyle: '0',
    };
  },
  components: {
    navBar,
    footerBar
  },
  watch: {
    $route: "init"
  },
  created() {
    this.changeTab()
  },
  methods: {
    clickTitle(tab, event) {
      this.titleStyle = tab.name;
      // this.$router.push(`/caseCar?type=${this.titleStyle}`);
      if(this.titleStyle === "1" || this.titleStyle === "2") {
        $(".el-tabs__active-bar").css("left", "-26px")
      } else {
        $(".el-tabs__active-bar").css("left", "-38px")
      }
    },
    init() {
      this.changeTab()
    },
    changeTab() {
      this.titleStyle = this.$route.query.type || '0';
      this.$nextTick(() => {
        if(this.titleStyle === '1' || this.titleStyle === '2') {
          $(".el-tabs__active-bar").css("left", "-26px")
        } else {
          $(".el-tabs__active-bar").css("left", "-38px")
        }
      })
    }
  },
};
</script>
<style  lang="scss" scoped>
.main {
  max-width: 1920px;
  min-width: $min-screen-width;
  overflow: hidden;
  margin: 0 auto;
  font-family: Source Han Sans CN;
  .banner {
    position: relative;
    height: 430px;
    .banner-title {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 645px;
    }
  }

  .title {
    margin-top: 100px;
    text-align: center;
    position: relative;
    font-size: 32px;
    // font-family: Source Han Sans CN;
    color: #333333;
    opacity: 1;
  }

  .title:after {
    content: " ";
    transform: translateX(-50%);
    width: 60px;
    height: 2px;
    background: #1f71ff;
    position: absolute;
    top: 52px;
    left: 50%;
  }

  .wrap-nav {
    margin: 0 auto;
    margin-top: 58px;
    width: 1200px;

    .content-box {
      margin-top: 29px;
      margin-bottom: 244px;
      
      .content-box images {
        width: 550px;
        height: 300px;
      }
      .content-box-describe {
        display: flex;
        justify-content: center;

        .content-box-title {
          img {
            width: 550px;
            height: 350px;
          }
          // margin-left: 100px;
          span {
            font-size: $font-size-20;
            font-family: Klein;
            font-weight: bold;
            color: #464646;
            padding-left: 61px;
          }
          div {
            margin-top: 37px;
            width: 550px;
            font-size: $font-size-18;
            font-family: SourceHanSansCN-Normal;
            line-height: 30px;
            color: #7e7e7e;
            padding-left: 61px;
          }
        }
      }
    }
  }
}

/deep/ .el-tabs__item {
  padding: 0 122px !important;
  font-size: $font-size-22;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #464646;
  line-height: 30px;
}

/deep/ .el-tabs__nav-wrap {
  margin-bottom: 65px;
}

/deep/ .el-tabs__active-bar {
  bottom: 0;
  left: -38px;
  width: 120px !important;
}

/deep/ .el-tabs__item.is-active {
  color: #409EFF !important;
}
</style>


// WEBPACK FOOTER //
// src/view/caseCar/index.vue